import { HiddenReason } from './Panel';

export interface Staging {
    idstaging: number;
    category: string | null;
    subcategory: string | null;
    client: string | null;
    rank: number | null;
    subcat_x: string | null;
    gene: string | null;
    rs: string | null;
    taqman: string | null;
    var_alias: string | null;
    notes: string | null;
    risk_allele: string | null;
    bene_allele: string | null;
    endophenotype: string | null;
    searcher: string | null;
    searcher_mod: string | null;
    GxE_pos: string | null;
    GxE_neg: string | null;
    epistasis: string | null;
    quality: number | null;
    actionable: string | null;
    modifiable: number | null;
    mod_type: any | null;
    marker_type: string | null;
    array_type: string | null;
    hz_coef: number | null;
    // Served additively by GET /staging alone (A4); every other staging endpoint keeps them hidden.
    trait_id?: number | null;
    wheel_gene_id?: number | null;
    is_hidden?: boolean;
    hidden_reason?: HiddenReason | null;
}


export interface StagingCategorySummary {
    category: string;
    snp_count: number;
    trait_count: number; 
}

export interface StagingSubcategorySummary {
    subcategory: string;
    snp_count: number;
}

export interface GeneListItem {
    gene: string;
    snp_count: number;
}

export interface BulkImportResult {
    created: number;
    updated: number;
    errors: Array<{
        index: number;
        rs: string;
        error: string;
    }>;
}

export const defaultStaging: Staging = {
    idstaging: 0,
    category: null,
    subcategory: null,
    client: null,
    rank: null,
    subcat_x: null,
    gene: null,
    rs: null,
    taqman: null,
    var_alias: null,
    notes: null,
    risk_allele: null,
    bene_allele: null,
    endophenotype: null,
    searcher: null,
    searcher_mod: null,
    GxE_pos: null,
    GxE_neg: null,
    epistasis: null,
    quality: 1,
    actionable: null,
    modifiable: 0,
    mod_type: null,
    marker_type: null,
    array_type: null,
    hz_coef: 1
};